import { render, staticRenderFns } from "./MovementFilters.vue?vue&type=template&id=4922a599"
import script from "./MovementFilters.vue?vue&type=script&lang=js"
export * from "./MovementFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports